import instance from "../http";
import { getHeader } from "../../utils/utils";
import { tones } from "../../constants/path";

export async function getToneApi(perPage = 10, page = 1, search = "", toneUUID) {
  const headers = getHeader();
  if(toneUUID !== undefined){
    const response = await instance.get(
      `${tones.GET_TONE}?page=${page}&perPage=${perPage}&search=${search}&selectedToneUUID=${toneUUID}`,
      headers
    );
    return response;
  }else{
    const response = await instance.get(
      `${tones.GET_TONE}?page=${page}&perPage=${perPage}&search=${search}`,
      headers
    );
    return response;
  } 
}

export async function createToneApi(payload) {
  const headers = getHeader();
  const response = await instance.post(
    tones.CREATE_TONE,
    payload,
    headers
  );
  return response;
}

export async function showToneApi(uuid) {
  const headers = getHeader();
  const response = await instance.get(
    tones.SHOW_TONE.replace(":uuid", uuid),
    headers
  );
  return response;
}

export async function updateToneApi(uuid, payload) {
  const headers = getHeader();
  const response = await instance.patch(
    tones.UPDATE_TONE.replace(":uuid", uuid),
    payload,
    headers
  );
  return response;
}

export async function deleteToneApi(uuid) {
  const headers = getHeader();
  const response = await instance.delete(
    tones.DELETE_TONE.replace(":uuid", uuid),
    headers
  );
  return response;
}

export async function bulkDeleteToneApi(uuids) {
  const headers = getHeader();
  const response = await instance.post(
    tones.BULK_DELETE_TONE,
    { prompt_tone_uuids: uuids },
    headers
  );
  return response;
}
